<template>
    <div class="schedule-form-container">
        <!-- 面包屑导航 -->
        <div class="breadcrumb-container">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/Welcome' }">
                    <i class="el-icon-s-home"></i>首页
                </el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/scheduleList' }">
                    <i class="el-icon-date"></i>展会排期列表
                </el-breadcrumb-item>
                <el-breadcrumb-item>
                    {{ formTitle }}
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <!-- 主内容卡片 -->
        <el-card class="main-card" shadow="hover">
            <!-- 头部操作区域 -->
            <div class="card-header">
                <div class="header-title">
                    <i class="el-icon-s-data"></i>
                    <span>{{ formTitle }}</span>
                </div>
                <div class="header-actions">
                    <el-button size="mini" icon="el-icon-back" @click="goBack">返回</el-button>
                </div>
            </div>

            <!-- 表单内容 -->
            <div class="form-container">
                <el-form
                        ref="scheduleForm"
                        :model="form"
                        :rules="rules"
                        label-width="120px"
                        size="mini"
                        :disabled="loading"
                >
                    <!-- 基本信息 -->
                    <div class="form-section">
                        <div class="section-title">基本信息</div>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="展会名称" prop="exhibition_id">
                                    <el-select
                                            v-model="form.exhibition_id"
                                            placeholder="请选择展会"
                                            filterable
                                            clearable
                                            style="width: 100%"
                                            @change="handleExhibitionChange"
                                    >
                                        <el-option
                                                v-for="item in exhibitionList"
                                                :key="item.id"
                                                :label="item.title"
                                                :value="item.id"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="所属展馆" prop="venue_id">
                                    <el-select
                                            v-model="form.venue_id"
                                            placeholder="请选择展馆"
                                            filterable
                                            clearable
                                            style="width: 100%"
                                    >
                                        <el-option
                                                v-for="item in venueList"
                                                :key="item.id"
                                                :label="item.title"
                                                :value="item.id"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="排期名称" prop="title">
                                    <el-input
                                            v-model="form.title"
                                            placeholder="请输入排期名称"
                                            maxlength="50"
                                            show-word-limit
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="排期状态" prop="status">
                                    <el-radio-group v-model="form.status">
                                        <el-radio :label="0">未开始</el-radio>
                                        <el-radio :label="1">进行中</el-radio>
                                        <el-radio :label="2">已结束</el-radio>
                                        <el-radio :label="3">已取消</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>

                    <!-- 时间信息 -->
                    <div class="form-section">
                        <div class="section-title">时间信息</div>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="开始时间" prop="start_time">
                                    <el-date-picker
                                            v-model="form.start_time"
                                            type="datetime"
                                            placeholder="选择开始时间"
                                            style="width: 100%"
                                            value-format="timestamp"
                                            :picker-options="startDatePickerOptions"
                                    ></el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="结束时间" prop="end_time">
                                    <el-date-picker
                                            v-model="form.end_time"
                                            type="datetime"
                                            placeholder="选择结束时间"
                                            style="width: 100%"
                                            value-format="timestamp"
                                            :picker-options="endDatePickerOptions"
                                    ></el-date-picker>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="布展时间" prop="setup_start_time">
                                    <el-date-picker
                                            v-model="form.setup_start_time"
                                            type="datetime"
                                            placeholder="选择布展开始时间"
                                            style="width: 100%"
                                            value-format="timestamp"
                                    ></el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="撤展时间" prop="teardown_end_time">
                                    <el-date-picker
                                            v-model="form.teardown_end_time"
                                            type="datetime"
                                            placeholder="选择撤展结束时间"
                                            style="width: 100%"
                                            value-format="timestamp"
                                    ></el-date-picker>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>

                    <!-- 展位信息 -->
                    <div class="form-section">
                        <div class="section-title">展位信息</div>
                        <el-row :gutter="20">
                            <el-col :span="8">
                                <el-form-item label="总展位数" prop="total_booths">
                                    <el-input-number
                                            v-model="form.total_booths"
                                            :min="0"
                                            :max="10000"
                                            placeholder="总展位数"
                                            style="width: 100%"
                                    ></el-input-number>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="可用展位" prop="available_booths">
                                    <el-input-number
                                            v-model="form.available_booths"
                                            :min="0"
                                            :max="form.total_booths"
                                            placeholder="可用展位数"
                                            style="width: 100%"
                                    ></el-input-number>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="标准展位价" prop="standard_price">
                                    <el-input
                                            v-model="form.standard_price"
                                            placeholder="标准展位价格"
                                            type="number"
                                            min="0"
                                    >
                                        <template slot="append">元</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>

                    <!-- 详细信息 -->
                    <div class="form-section">
                        <div class="section-title">详细信息</div>
                        <el-form-item label="排期描述" prop="description">
                            <el-input
                                    v-model="form.description"
                                    type="textarea"
                                    :rows="4"
                                    placeholder="请输入排期描述"
                                    maxlength="500"
                                    show-word-limit
                            ></el-input>
                        </el-form-item>

                        <el-form-item label="注意事项" prop="notes">
                            <el-input
                                    v-model="form.notes"
                                    type="textarea"
                                    :rows="3"
                                    placeholder="请输入注意事项"
                                    maxlength="300"
                                    show-word-limit
                            ></el-input>
                        </el-form-item>

                        <el-form-item label="展位平面图" prop="layout_image">
                            <el-upload
                                    class="upload-demo"
                                    action="/api/upload"
                                    :headers="uploadHeaders"
                                    :on-success="handleLayoutImageSuccess"
                                    :on-remove="handleLayoutImageRemove"
                                    :before-upload="beforeImageUpload"
                                    :file-list="layoutImageList"
                                    list-type="picture"
                                    :limit="1"
                            >
                                <el-button size="mini" type="primary">点击上传</el-button>
                                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2MB</div>
                            </el-upload>
                        </el-form-item>
                    </div>

                    <!-- 操作按钮 -->
                    <div class="form-actions">
                        <el-button
                                size="mini"
                                @click="goBack"
                        >取消</el-button>
                        <el-button
                                size="mini"
                                type="primary"
                                :loading="loading"
                                @click="submitForm"
                        >保存</el-button>
                        <el-button
                                size="mini"
                                v-if="isEdit"
                                @click="resetForm"
                        >重置</el-button>
                    </div>
                </el-form>
            </div>
        </el-card>
    </div>
</template>

<script>

    export default {
        name: "ScheduleForm",
        data() {
            // 结束时间验证规则
            const validateEndTime = (rule, value, callback) => {
                if (!value) {
                    callback(new Error('请选择结束时间'));
                } else if (this.form.start_time && value <= this.form.start_time) {
                    callback(new Error('结束时间必须晚于开始时间'));
                } else {
                    callback();
                }
            };

            // 可用展位验证规则
            const validateAvailableBooths = (rule, value, callback) => {
                if (value === null || value === '') {
                    callback(new Error('请输入可用展位数'));
                } else if (this.form.total_booths && value > this.form.total_booths) {
                    callback(new Error('可用展位数不能超过总展位数'));
                } else {
                    callback();
                }
            };

            return {
                loading: false,
                isEdit: false,
                scheduleId: null,

                // 表单数据
                form: {
                    exhibition_id: '',
                    venue_id: '',
                    title: '',
                    status: 0,
                    start_time: '',
                    end_time: '',
                    setup_start_time: '',
                    teardown_end_time: '',
                    total_booths: 0,
                    available_booths: 0,
                    standard_price: '',
                    description: '',
                    notes: '',
                    layout_image: ''
                },

                // 表单验证规则
                rules: {
                    exhibition_id: [
                        { required: true, message: '请选择展会', trigger: 'change' }
                    ],
                    venue_id: [
                        { required: true, message: '请选择展馆', trigger: 'change' }
                    ],
                    title: [
                        { required: true, message: '请输入排期名称', trigger: 'blur' },
                        { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
                    ],
                    start_time: [
                        { required: true, message: '请选择开始时间', trigger: 'change' }
                    ],
                    end_time: [
                        { required: true, validator: validateEndTime, trigger: 'change' }
                    ],
                    total_booths: [
                        { required: true, message: '请输入总展位数', trigger: 'blur' }
                    ],
                    available_booths: [
                        { required: true, validator: validateAvailableBooths, trigger: 'blur' }
                    ],
                    standard_price: [
                        { required: true, message: '请输入标准展位价格', trigger: 'blur' }
                    ]
                },

                // 展会列表
                exhibitionList: [],
                // 展馆列表
                venueList: [],

                // 上传相关
                uploadHeaders: {
                    'Authorization': 'Bearer ' + sessionStorage.getItem('token')
                },
                layoutImageList: [],

                // 日期选择器配置
                startDatePickerOptions: {
                    disabledDate: (time) => {
                        return time.getTime() < Date.now() - 8.64e7;
                    }
                },
                endDatePickerOptions: {
                    disabledDate: (time) => {
                        if (this.form.start_time) {
                            return time.getTime() < this.form.start_time;
                        }
                        return time.getTime() < Date.now() - 8.64e7;
                    }
                }
            };
        },
        computed: {
            formTitle() {
                return this.isEdit ? '编辑展会排期' : '新增展会排期';
            }
        },
        created() {
            this.scheduleId = this.$route.query.id;
            this.isEdit = !!this.scheduleId;

            this.getExhibitionList();
            this.getVenueList();

            if (this.isEdit) {
                this.getScheduleDetail();
            }
        },
        methods: {
            // 获取展会列表
            getExhibitionList() {
                const param = {
                    company_id: sessionStorage.getItem('company_id'),
                    access_token: sessionStorage.getItem('token'),
                    pageNum: 1,
                    pageSize: 1000
                }

                this.$axios.exhibitionListP(param).then(res => {
                    if (res.code == 200) {
                        this.exhibitionList = res.data.data || [];
                    }
                }).catch(error => {
                    console.log(error);
                    this.$message.error('获取展会列表失败');
                })
            },

            // 获取展馆列表
            getVenueList() {
                const param = {
                    company_id: sessionStorage.getItem('company_id'),
                    access_token: sessionStorage.getItem('token'),
                    pageNum: 1,
                    pageSize: 1000
                }

                this.$axios.venueListP(param).then(res => {
                    if (res.code == 200) {
                        this.venueList = res.data.data || [];
                    }
                }).catch(error => {
                    console.log(error);
                    this.$message.error('获取展馆列表失败');
                })
            },

            // 获取排期详情
            getScheduleDetail() {
                this.loading = true;
                const param = {
                    company_id: sessionStorage.getItem('company_id'),
                    access_token: sessionStorage.getItem('token'),
                    id: this.scheduleId
                }

                this.$axios.scheduleDetail(param).then(res => {
                    this.loading = false;
                    if (res.code == 200) {
                        const data = res.data;
                        // 填充表单数据
                        Object.keys(this.form).forEach(key => {
                            if (data[key] !== undefined && data[key] !== null) {
                                this.form[key] = data[key];
                            }
                        });

                        // 处理图片
                        if (data.layout_image) {
                            this.layoutImageList = [{
                                name: '展位平面图',
                                url: data.layout_image
                            }];
                        }
                    } else {
                        this.$message.error(res.msg || '获取排期详情失败');
                    }
                }).catch(error => {
                    this.loading = false;
                    console.log(error);
                    this.$message.error('获取排期详情失败');
                })
            },

            // 处理展会选择变化
            handleExhibitionChange(exhibitionId) {
                if (exhibitionId) {
                    const exhibition = this.exhibitionList.find(item => item.id === exhibitionId);
                    if (exhibition && !this.form.title) {
                        this.form.title = `${exhibition.title}排期`;
                    }
                }
            },

            // 图片上传前的验证
            beforeImageUpload(file) {
                const isJPGorPNG = file.type === 'image/jpeg' || file.type === 'image/png';
                const isLt2M = file.size / 1024 / 1024 < 2;

                if (!isJPGorPNG) {
                    this.$message.error('上传图片只能是 JPG/PNG 格式!');
                }
                if (!isLt2M) {
                    this.$message.error('上传图片大小不能超过 2MB!');
                }
                return isJPGorPNG && isLt2M;
            },

            // 平面图上传成功
            handleLayoutImageSuccess(response) {
                if (response.code === 200) {
                    this.form.layout_image = response.data.url;
                    this.$message.success('上传成功');
                } else {
                    this.$message.error(response.msg || '上传失败');
                }
            },

            // 移除平面图
            handleLayoutImageRemove() {
                this.form.layout_image = '';
            },

            // 提交表单
            submitForm() {
                this.$refs.scheduleForm.validate((valid) => {
                    if (valid) {
                        this.loading = true;

                        // 准备提交数据
                        const submitData = {
                            ...this.form,
                            company_id: sessionStorage.getItem('company_id'),
                            access_token: sessionStorage.getItem('token'),
                            operator_id: sessionStorage.getItem('user_id')
                        };

                        // 转换时间格式
                        if (submitData.start_time) {
                            submitData.start_time = Math.floor(submitData.start_time / 1000);
                        }
                        if (submitData.end_time) {
                            submitData.end_time = Math.floor(submitData.end_time / 1000);
                        }
                        if (submitData.setup_start_time) {
                            submitData.setup_start_time = Math.floor(submitData.setup_start_time / 1000);
                        }
                        if (submitData.teardown_end_time) {
                            submitData.teardown_end_time = Math.floor(submitData.teardown_end_time / 1000);
                        }

                        let apiCall;
                        if (this.isEdit) {
                            submitData.id = this.scheduleId;
                            apiCall = this.$axios.scheduleUpdate(submitData);
                        } else {
                            apiCall = this.$axios.scheduleSave(submitData);
                        }

                        apiCall.then(res => {
                            this.loading = false;
                            if (res.code == 200) {
                                this.$message.success(res.msg);
                                this.$router.push('/scheduleList');
                            } else {
                                this.$message.error(res.msg || '保存失败');
                            }
                        }).catch(error => {
                            this.loading = false;
                            console.log(error);
                            this.$message.error('保存失败，请稍后重试');
                        });
                    } else {
                        this.$message.warning('请完善表单信息');
                        return false;
                    }
                });
            },

            // 重置表单
            resetForm() {
                if (this.isEdit) {
                    this.getScheduleDetail();
                } else {
                    this.$refs.scheduleForm.resetFields();
                    this.layoutImageList = [];
                }
            },

            // 返回列表
            goBack() {
                this.$router.push('/scheduleList');
            }
        }
    };
</script>

<style scoped>
    .schedule-form-container {
        padding: 20px;
        background-color: #f5f7fa;
        min-height: calc(100vh - 84px);
    }

    .breadcrumb-container {
        margin-bottom: 20px;
    }

    .main-card {
        border-radius: 8px;
        border: none;
    }

    .card-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 20px;
        border-bottom: 1px solid #ebeef5;
        margin-bottom: 20px;
    }

    .header-title {
        display: flex;
        align-items: center;
        font-size: 18px;
        font-weight: 600;
        color: #303133;
    }

    .header-title i {
        margin-right: 8px;
        color: #409EFF;
    }

    .form-container {
        max-width: 1000px;
        margin: 0 auto;
    }

    .form-section {
        margin-bottom: 30px;
        padding: 20px;
        background: #fff;
        border-radius: 8px;
        border: 1px solid #ebeef5;
    }

    .section-title {
        font-size: 16px;
        font-weight: 600;
        color: #303133;
        margin-bottom: 20px;
        padding-bottom: 10px;
        border-bottom: 1px solid #ebeef5;
    }

    .form-actions {
        text-align: center;
        padding: 20px 0;
        border-top: 1px solid #ebeef5;
        margin-top: 30px;
    }

    .form-actions .el-button {
        margin: 0 10px;
    }

    /* 响应式调整 */
    @media (max-width: 768px) {
        .schedule-form-container {
            padding: 10px;
        }

        .card-header {
            flex-direction: column;
            align-items: flex-start;
        }

        .header-actions {
            margin-top: 10px;
        }

        .form-container {
            padding: 0 10px;
        }

        .form-section {
            padding: 15px;
        }
    }

    /* 自定义样式 */
    .upload-demo {
        width: 100%;
    }

    .upload-demo .el-upload {
        width: 100%;
    }

    .upload-demo .el-upload-dragger {
        width: 100%;
    }
</style>
